import styled, { css } from 'styled-components';
import scoreStaticImage from 'images/sports/common/sp_livescore.png';
import React from 'react';

export const TeamName = styled.div`
  width: 21px;
  height: 9px;
  margin-left: 10px;
  margin-top: 5px;
  background: url(${scoreStaticImage}) no-repeat 0 -90px;
  ${(props) =>
    props.position === 'HOME' &&
    css`
      background-position: 0 -100px;
    `};
`;
export const Table = styled.table`
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;

  border: 1px solid #d1d1d1;
  & thead th {
    background: #fafafa;
    height: 30px;
    &:not(:last-child) {
      border-right: 1px solid #e9e9e9;
    }
    border-bottom: 1px solid #d1d1d1;
  }

  & tbody th {
    height: 50px;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    text-align: left;
    text-indent: 10px;
  }
  & tbody td {
    width: 82px;
    position: relative;
    text-align: center;
    &:not(:last-child) {
      border-right: 1px solid #e9e9e9;
    }
    border-bottom: 1px solid #e9e9e9;
  }

  & tfoot th {
    height: 30px;
    border-right: 1px solid #e9e9e9;
    text-align: left;
    text-indent: 10px;
  }

  & tfoot td {
    text-align: center;
    &:not(:last-child) {
      border-right: 1px solid #e9e9e9;
    }
    background: #fafafa;
  }
`;

export const SpecialWrapper = styled.div`
  height: 13px;
  overflow: hidden;
  position: absolute;

  width: 98%;
  bottom: 1px;
  left: 2px;
  background: url(${scoreStaticImage}) no-repeat -70px -130px;

  & > span {
    position: absolute;
    bottom: 0;
    display: inline-block;
    content: '';
    width: 12px;
    height: 13px;
    background: url(${scoreStaticImage}) no-repeat 0 -9999px;
  }
`;

export const Point = styled.span`
  left: 0;
  background-position: -70px -170px !important;
`;
export const Three = styled.span`
  left: 13px;
  background-position: -90px -170px !important;
`;
export const Free = styled.span`
  left: 26px;
  background-position: -110px -170px !important;
`;
export const Point5 = styled.span`
  left: 39px;
  background-position: -130px -170px !important;
`;
export const Point7 = styled.span`
  left: 52px;
  background-position: -150px -170px !important;
`;
export const Point10 = styled.span`
  left: 65px;
  background-position: -170px -170px !important;
`;
